import { createStyles, makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { Theme } from '@mui/material/styles';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    backdrop: {
      zIndex: 1500,
      color: '#2D91E9',
      backgroundColor: 'rgba(255,255,255,0.65)'
    }
  })
);

export default function APBackdropLoader(props: any) {
  const classes = useStyles();
  const { open } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const handleBeforeUnload = () => {
      setIsLoading(true);
    };

    const handleLoad = () => {
      setIsLoading(false);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return (
    <div className={classes.root}>
      <Backdrop data-testid="backdrop-loader" className={classes.backdrop} open={open || isLoading}>
        <CircularProgress color="inherit" size={"75px"} data-testid="progressbar" role="progressbar" />
      </Backdrop>
    </div>
  );
}
